import portfolioData from '../data/portfolio.json';
import { motion } from 'framer-motion';

const Bio = () => {
  const { profile } = portfolioData;

  // Highlight specific keywords to break visual monotony
  const highlightKeywords = (text) => {
    const keywords = ["Full Stack Developer", "React Native", "Django REST Framework", "AsiaBasket", "Infi Web Tech"];
    const regex = new RegExp(`(${keywords.join('|')})`, 'gi');
    const parts = text.split(regex);

    return parts.map((part, i) =>
      keywords.some(k => k.toLowerCase() === part.toLowerCase())
        ? <span key={i} className="font-semibold text-stone-800 dark:text-stone-100 bg-stone-200/50 dark:bg-stone-700/50 px-2.5 py-0.5 rounded-md inline-block mx-0.5 shadow-sm">{part}</span>
        : part
    );
  };

  return (
    <section className="py-24 w-full relative" id="bio">
      {/* Soft background glow for the section */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[60%] h-[60%] bg-stone-200/30 dark:bg-stone-700/20 rounded-full blur-[100px] -z-10"></div>

      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="mb-14 text-center text-4xl font-light tracking-wide text-stone-800 dark:text-stone-200"
      >
        My Story
      </motion.h2>
      <div className='flex flex-col items-center justify-center max-w-4xl mx-auto px-4'>
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="relative w-full p-10 md:p-14 bg-white/60 dark:bg-stone-800/60 backdrop-blur-xl rounded-[2rem] shadow-lg border border-white/40 dark:border-stone-600/30 overflow-hidden group"
        >
          {/* Decorative quote mark */}
          <div className="absolute top-4 left-6 text-9xl text-stone-200/50 dark:text-stone-700/30 font-serif leading-none select-none pointer-events-none transition-transform duration-700 group-hover:-rotate-12 group-hover:scale-110">
            "
          </div>

          <p className="relative z-10 text-xl md:text-2xl text-stone-600 dark:text-stone-300 font-light leading-relaxed md:leading-[2.2rem] text-justify max-w-3xl mx-auto">
            {highlightKeywords(profile.summary)}
          </p>

          {/* Subtle bottom gradient line */}
          <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-stone-400/30 dark:via-stone-500/30 to-transparent"></div>
        </motion.div>
      </div>
    </section>
  )
}

export default Bio
